<div class="input-wrapper" [class.focused]="focused" [class.invalid]="invalid">
  <label *ngIf="label" class="input-label">{{ label }}</label>

  <div class="input-container">
    <input
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      [value]="value()"
    />

    <button
      *ngIf="clearable && value()"
      type="button"
      class="clear-input-btn"
      (click)="clear()"
    >
      ✕
    </button>
  </div>

  <small *ngIf="hint && !invalid" class="input-hint">{{ hint }}</small>
  <small *ngIf="error && invalid" class="input-error">{{ error }}</small>
</div>
